import { Page, Text, View } from '@react-pdf/renderer';

import { InfoPageProps } from 'interfaces/components/dashboardPdf';

import { InfoTitle } from './title';
import { PdfFooter } from '../pdfFooter';
import { PdfHeader } from '../pdfHeader';
import { Statistics } from './statistics';
import { InfoContainer } from './container';
import { getPdfInfo } from 'utils/helpers/mapPdfInfo';

export const InfoPage = ({
  pagesCount,
  companyName,
  companyInfo
}: InfoPageProps) => {
  const infoSections = getPdfInfo(companyInfo);

  return (
    <Page
      size='A4'
      orientation='landscape'
      style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}
    >
      <PdfHeader />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          paddingHorizontal: '20px'
        }}
      >
        <Text
          style={{ fontSize: '16px', fontWeight: 'semibold', color: '#151515' }}
        >
          ICONIQ Enterprise Five
        </Text>

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          The ICONIQ Enterprise Five can help you determine the health of your
          business. Startups often include these metrics in regular reporting to
          understand the drivers of revenue and profit performance and support
          strategic planning decisions on everything from GTM strategy to team
          size.
        </Text>

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          The numbers, figures, and case studies presented here are
          illustrative, and there is no guarantee that the actual results
          achieved by any ICONIQ portfolio or partners or affiliates will match
          those in the tool. Past performance is not a guide to future
          performance, and any investment may result in the loss of all or part
          of the money invested.
        </Text>
      </View>

      <Statistics companyInfo={companyInfo} />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          paddingHorizontal: '20px'
        }}
      >
        <InfoTitle
          name={companyName}
          status={companyInfo.requiredInfo.status || ''}
          website={companyInfo.companyDetails.companyWebsite}
        />

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          Below, you'll find the user parameters you provided, along with
          corresponding graphs that visualize these comparisons.
        </Text>
      </View>

      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          justifyContent: 'space-between',
          gap: '8px',
          padding: '8px',
          marginHorizontal: '20px',
          borderRadius: '8px',
          border: '1px solid #F2F2F2'
        }}
      >
        {infoSections.map((section, index) => (
          <View
            key={index}
            style={{
              flex: 1,
              paddingRight: index === infoSections.length - 1 ? 0 : '8px',
              borderRight:
                index === infoSections.length - 1 ? 'none' : '1px solid #F2F2F2'
            }}
          >
            <InfoContainer key={index} info={section} />
          </View>
        ))}
      </View>

      <PdfFooter pageNumber={1} pagesCount={pagesCount} />
    </Page>
  );
};
